import type { ObjectCommentContainerPreloadObjectCommentsQuery$variables } from './components/__generated__/ObjectCommentContainerPreloadObjectCommentsQuery.graphql.ts';

export const PRELOAD_FOOTER_COMMENTS_COUNT = 3;

// Shared by the preloader and readers without importing footer rendering/data-manager code.
export const buildPreloadObjectCommentsQueryVariables = (
	contentId: string,
	includeConversationData = false,
	includeCommentThreads = false,
	focusedCommentId?: string,
	includeFocusedComment = false,
): ObjectCommentContainerPreloadObjectCommentsQuery$variables => ({
	pageId: contentId,
	contentStatus: ['DRAFT', 'CURRENT', 'ARCHIVED'],
	first: PRELOAD_FOOTER_COMMENTS_COUNT,
	includeCommentReactions: true,
	includeConversationData,
	includeCommentThreads,
	focusedCommentId: focusedCommentId ?? null,
	includeFocusedComment,
});
